/* eslint-disable react/button-has-type */
import React from 'react';
import { useLocation } from '@reach/router';

import { useLanguage } from '../hooks/useLanguage';
import { useDataLayer } from '../hooks/useDataLayer';
import { useUseStaticQuery } from '../hooks/useUseStaticQuery';
import { isStagingEnv } from '../utils/environment';

const AnchorNativeElement = ({ style, button = {}, children, onClick }) => {
  // Get data from different resources
  const { eventsorting } = useDataLayer();
  const location = useLocation();
  const { language } = useLanguage();
  const { externalLinks } = useUseStaticQuery();

  const { externalLink, href, ariaLabel, identifier = '' } = button;

  // Handle params and envs when redirection to Customio
  const isToCustomio =
    externalLink === 'signup' ||
    externalLink === 'quoting' ||
    externalLink === 'login';
  const path = `${location?.pathname}${identifier}`;
  const params = isToCustomio
    ? `?${path ? `sector=fine_art&source=website&path=${path}` : ''}${
        eventsorting ? `&eventsorting=${eventsorting}` : ''
      }`
    : '';

  // Add language to url if external link redirects to Help Center
  const isToHelpCenter = externalLink === 'helpCenter';

  // Get external links
  const getHref = () => {
    const link = `${externalLinks[externalLink]}${
      isToHelpCenter ? `/${language}` : ''
    }${params}`;

    if (isStagingEnv && isToCustomio) {
      return `${link.replace('web', 'staging')}`;
    } else return link;
  };

  return (
    <a
      className={style}
      href={href || getHref()}
      target="_blank"
      rel={`${!isToCustomio ? 'nofollow ' : ''}noreferrer`}
      aria-label={ariaLabel}
      onClick={onClick}
    >
      {children}
    </a>
  );
};

export default AnchorNativeElement;
